import { useContext } from "react";
import {
  Button, Calendar, CalendarCell, CalendarGrid, CalendarGridBody,
  CalendarGridHeader, CalendarHeaderCell, CalendarStateContext, Heading,
} from "react-aria-components";
import { getLocalTimeZone, today } from "@internationalized/date";
import { ChevronLeft, ChevronRight } from "lucide-react";

function CalendarToday() {
  const state = useContext(CalendarStateContext);
  const date = today(getLocalTimeZone());
  return (
    <footer className="co-calendar-footer">
      <span>Pick a date</span>
      <Button
        slot={null}
        className="co-calendar-today"
        isDisabled={!state || state.isDisabled || state.isReadOnly || (state.isInvalid(date) || state.isCellUnavailable(date))}
        onPress={() => { state?.setFocusedDate(date); state?.setValue(date); }}
      >Today</Button>
    </footer>
  );
}

/** Shared accessible calendar; inherits date bounds from its DatePicker. */
export default function DatePickerCalendar() {
  return (
    <Calendar className="co-calendar">
      <header className="co-calendar-header">
        <Heading />
        <Button slot="previous" className="co-calendar-nav">
          <ChevronLeft className="size-4" aria-hidden />
        </Button>
        <Button slot="next" className="co-calendar-nav">
          <ChevronRight className="size-4" aria-hidden />
        </Button>
      </header>
      <CalendarGrid className="co-calendar-grid">
        <CalendarGridHeader>
          {(day) => <CalendarHeaderCell>{day}</CalendarHeaderCell>}
        </CalendarGridHeader>
        <CalendarGridBody>
          {(date) => <CalendarCell date={date} className="co-calendar-day" />}
        </CalendarGridBody>
      </CalendarGrid>
      <CalendarToday />
    </Calendar>
  );
}
